import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import I18nextBrowserLanguageDetector from 'i18next-browser-languagedetector';

// Import des fichiers de traduction originaux
import enTranslations from './locales/en.json';
import frTranslations from './locales/fr.json';

// Import des fichiers de traduction spécifiques au conducteur
import enDriverTranslations from './locales/driver/en.json';
import frDriverTranslations from './locales/driver/fr.json';

// Import des fichiers de traduction pour la réservation
import enReservationTranslations from './locales/en/reservation.json';
import frReservationTranslations from './locales/fr/reservation.json';

// Import des fichiers de traduction pour le tableau de bord
import enDashboardTranslations from './locales/en/dashboard.json';
import frDashboardTranslations from './locales/fr/dashboard.json';

export const resources = {
  en: {
    translation: enTranslations,
    driver: enDriverTranslations,
    reservation: enReservationTranslations,
    dashboard: enDashboardTranslations,
  },
  fr: {
    translation: frTranslations,
    driver: frDriverTranslations,
    reservation: frReservationTranslations,
    dashboard: frDashboardTranslations,
  },
} as const;

console.log('Initializing i18next...', {
  defaultNS: 'translation',
  namespaces: ['translation', 'driver', 'reservation', 'dashboard']
});

i18next
  .use(I18nextBrowserLanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    defaultNS: 'translation',
    ns: ['translation', 'driver', 'reservation', 'dashboard'],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  })
  .then(() => {
    console.log('i18next initialized successfully');
  })
  .catch((error) => {
    console.error('Error initializing i18next:', error);
  });

i18next.on('languageChanged', (lng) => {
  console.log('Language changed to:', lng);
});

export default i18next;
